import React from "react";
import SupportersList from "./supporters-list";
import { FormattedMessage } from "react-intl";
import useSupporters from "./use-supporters";
import { useWindowScroll } from "react-use";
import { AnimatePresence, motion } from "framer-motion";

const SupportersHeader = () => {
  const { isActive } = useSupporters();
  const { y } = useWindowScroll();
  const isTop = y === 0;

  if (!isActive) return;

  return (
    <AnimatePresence>
      {isTop && (
        <motion.div
          className="supporters-header"
          initial={{ opacity: 0, filter: "blur(30px)" }}
          animate={{ opacity: 1, filter: "blur(0)" }}
          exit={{ opacity: 0, filter: "blur(30px)" }}
        >
          <span className="supporters-title">
            <FormattedMessage id="timetable_supported_label" />
          </span>
          <SupportersList />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SupportersHeader;
